import React, { useEffect, useState } from 'react';
import { Text, View } from "../../Components/Themed"
import moment from 'moment-mini';
import { CampaignApi, CampaignHelpers } from '../api';
import type { CampaignParticipantProps, NewOverallAnalytics, OrderAnalyticsProps, PublicPlayerProps } from '../../types';
import { ActivityIndicator, FlatList, Image } from 'react-native';
import { useColors } from '../../constants/useColors';
import { Icons } from '../../Components';
import { CompetitionHelpers } from '../../Competition/api';


type CampaignLeaderboardProps = {
    campaign_id:string,
    players:PublicPlayerProps[],
    campaign_participants:CampaignParticipantProps[]
}

const CampaignLeaderboard = ({ campaign_id, players, campaign_participants }:CampaignLeaderboardProps) => {
    const Colors = useColors();
    const time_options = [
        { label: 'Last Year', to: moment().unix(), from: moment().subtract(365, 'days').unix() }
    ]

    const [ module_state, setModuleState ] = useState<{
        loading:boolean,
        time_option: any,
        analytics:OrderAnalyticsProps[]
    }>({
        loading:true,
        time_option: time_options[0],
        analytics: []
    });
    const { loading, analytics } = module_state;

    useEffect(() => {
        let option = time_options[0]
        if(!option){ return }
        handleLoadAnalytics(option);
    },[])

    const handleLoadAnalytics = async(option:{ label:string, to:number, from:number }) => {
        CampaignApi.setEnvironment();
        setModuleState({ ...module_state, loading:true });
        const analytics = await CampaignApi.getCampaignAnalytics(campaign_id, option.to, option.from);
        setModuleState({
            ...module_state,
            loading:false,
            time_option: option,
            analytics
        })
    }

    const renderLeaders = (data:{ item:NewOverallAnalytics, index:number }) => {
        const player = players.find(p => p.player_id == data.item.player_id);
        if(!player){ return <></> }
        const participant = campaign_participants.find(cp => cp.player_id == data.item.player_id);
        return (
            <View style={{ flexDirection:'row', alignItems:'center', padding:10, borderBottomWidth:1, borderColor:Colors.borders.light }}>
                <View transparent style={{ paddingRight:10, borderRightWidth:1, borderColor:Colors.borders.light }}>
                    <Text theme='h1'>{CompetitionHelpers.formatPlace(data.index + 1)}</Text>
                </View>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:40, width:40, borderRadius:100, marginLeft:10 }}
                />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>@{player.username}</Text>
                    {participant ?
                    <Text theme='description' style={{ marginTop:3 }}>First checked in {moment(participant.create_datetime).fromNow()}</Text>
                    :<></>}
                </View>
                <View>
                    <Text theme='description' color={data.item.roi_pct >= 0 ? Colors.text.success : Colors.text.error}>{(data.item.roi_pct * 100).toFixed(2)}%</Text>
                </View>
            </View>
        )
    }

    const leaders = CampaignHelpers.getCampaignLeaderboard(analytics);
    return (
        <View>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                <Icons.LeaderboardIcon size={28} color={Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>Leaderboard</Text>
                    <Text theme='description' style={{ marginTop:3 }}>Leaders based on action placed while checked in</Text>
                </View>
                <View transparent style={{ marginLeft:5 }}>
                    <Text theme='action'>ROI %</Text>
                </View>
            </View>
            <View transparent>
                {loading ?
                <ActivityIndicator style={{ margin:20 }} size='large' color={Colors.text.h1} />
                :<></>}
                {leaders.length > 0 ?
                <FlatList
                    data={leaders}
                    key={'campaign_leaders'}
                    keyExtractor={(item) => item.player_id.toString()}
                    renderItem={renderLeaders}
                />
                : !loading ?
                <View style={{ alignItems:'center', padding:10 }}>
                    <View float style={{ height:120, width:120, borderRadius:8, padding:10, justifyContent:'center', alignItems:'center' }}>
                        <Icons.LeaderboardIcon size={36} color={Colors.text.h1} />
                        <Text theme='h1' style={{ marginTop:10 }} textAlign='center'>No Data Yet!</Text>
                    </View>
                </View>
                :<></>}
            </View>
        </View>
    )
}

export default CampaignLeaderboard